<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import BaseChart from '@/charts/BaseChart.vue'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'


const props = defineProps<{
	data: {
		current: number
		previous: number
	}
	size?: 'small' | 'medium' | 'large'
	height?:number
}>()

const growthRate = computed(() => {
	if (props.data.previous === 0) return 100
	return ((props.data.current - props.data.previous) / props.data.previous) * 100
})

const chartOptions = computed(() => ({
	series: [
		{
			type: 'gauge',
			startAngle: 90,
			endAngle: -270,
			pointer: {
				show: false
			},
			progress: {
				show: true,
				overlap: false,
				roundCap: true,
				clip: false,
				itemStyle: {
					color: growthRate.value >= 0 ? '#22c55e' : '#ef4444'
				}
			},
			axisLine: {
				lineStyle: {
					width: 10
				}
			},
			splitLine: {
				show: false
			},
			axisTick: {
				show: false
			},
			axisLabel: {
				show: false
			},
			detail: {
				valueAnimation: true,
				fontSize: 24,
				fontWeight: 'bolder',
				formatter: '{value}',
				color: 'inherit'
			},
			data: [
				{
					value: Math.round(growthRate.value),
					name: 'Growth Rate'
				}
			]
		}
	]
}))
</script>

<template>
		<Card :style="'height:'+height">
		<CardContent>
		<div class="text-center mt-2"> 
			<p class="text-headline font-semibold">{{ props.data.current }}</p>
			<h3 class="text-subtitle">New Users</h3>
			<p class="text-sm" :class="growthRate >= 0 ? 'text-green-500' : 'text-red-500'">
			{{ growthRate >= 0 ? '↑' : '↓' }} {{ Math.abs(growthRate).toFixed(1) }}%
			</p>
		</div>
		</CardContent>
		</Card>
</template>
